import React from 'react';
import {
   BecomeAClientWrapper,
   BecomeAClientBackground,
   BecomeAClientImageContainer,
   BecomeAClientImage,
   BecomeAClientHeader,
   BecomeAClientHeaderSpan,
   BecomeAClientInfo,
   BecomeAClientButton,
   BecomeAClientSubmit
} from './BecomeAClient.styled';

import config from './../../config';

export default class BecomeAClient extends React.Component {
   public render() {
      return (
         <BecomeAClientWrapper>
            <BecomeAClientBackground />
            <BecomeAClientImageContainer>
               <BecomeAClientImage width={418} height={300} src={`${config.baseName}/images/become-a-client-cta-min.png`} alt='Become a Client' />
            </BecomeAClientImageContainer>
            <BecomeAClientHeader>
               Does your company <BecomeAClientHeaderSpan>already subscribe</BecomeAClientHeaderSpan>?
            </BecomeAClientHeader>
            <BecomeAClientInfo>Find out if your company offers access to EMARKETER.</BecomeAClientInfo>
            <BecomeAClientSubmit>
               <BecomeAClientButton href={`${config.iiHomeUrl}/does-my-company-subscribe/`} rel='noreferrer' data-analytics='Forecast-CTA-BecomeAClient'>
                  Get access
               </BecomeAClientButton>
            </BecomeAClientSubmit>
         </BecomeAClientWrapper>
      );
   }
}
